module.exports = __webpack_public_path__ + "img/tab7.7df58237.svg";